"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Adminet API Reference
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.92
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentItemTypeCodeToJSON = exports.ComponentItemTypeCodeFromJSONTyped = exports.ComponentItemTypeCodeFromJSON = exports.ComponentItemTypeCode = void 0;
/**
 * Type code values:
 * * `0` Laskutus
 * * `1` Työ (palkat ja palkkiot)
 * * `2` Tuote (ainekäyttö)
 * * `3` Alihankinta (ulkopuoliset palvelut)
 * * `4` Omat (omat palvelut / kulut)
 * * `5` Muut (muut kulut)
 * * `S` Sivukulu (työn sivukulut)
 * * `K` Korvaus (korvaukset)
 * @export
 */
exports.ComponentItemTypeCode = {
    _0: '0',
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5',
    S: 'S',
    K: 'K'
};
function ComponentItemTypeCodeFromJSON(json) {
    return ComponentItemTypeCodeFromJSONTyped(json, false);
}
exports.ComponentItemTypeCodeFromJSON = ComponentItemTypeCodeFromJSON;
function ComponentItemTypeCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ComponentItemTypeCodeFromJSONTyped = ComponentItemTypeCodeFromJSONTyped;
function ComponentItemTypeCodeToJSON(value) {
    return value;
}
exports.ComponentItemTypeCodeToJSON = ComponentItemTypeCodeToJSON;
